export default __webpack_public_path__ + "static/media/friendship2.10819480.jpg";